import React from 'react';
import useMedia from 'use-media';
import MenuDesktop  from './menuDesktop';
import MenuMovil from './menuMovil';

function Menu() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    return (
      <div>
        {isLargeScreen && <MenuDesktop/>}
        {isSmallScreen && <MenuMovil/>}
      </div>
    );
  }
  
  export default Menu;
